export interface ChangesState {
  lastChangeId: string | null;
}

export const initialChangesState: Readonly<ChangesState> = {
  lastChangeId: null
};
